import { useState } from 'react';
import { Link } from 'react-router-dom';
import useSeo from '@/hooks/useSeo';
import { newsList } from '@/mocks/news';
import PageHero from '@/components/base/PageHero';
import EmptyState from '@/components/base/EmptyState';
import Pagination from '@/components/base/Pagination';

const PAGE_SIZE = 6;

export default function NewsListPage() {
  useSeo(
    '动漫资讯 - 妖精动漫',
    '妖精动漫资讯频道，汇集最新动漫行业动态、新番消息、幕后探访与每周汇总，第一时间了解动画世界发生的事。',
    '动漫资讯,动漫新闻,新番动态,行业动态,妖精动漫',
  );

  const [page, setPage] = useState(1);
  const sorted = [...newsList].sort((a, b) => (a.date < b.date ? 1 : -1));
  const totalPages = Math.ceil(sorted.length / PAGE_SIZE);
  const paged = sorted.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <div className="w-full">
      <PageHero
        title="动漫资讯"
        subtitle="最新新番动态、行业观察与幕后故事，一页看全动漫世界正在发生的事。"
        crumbs={[{ label: '首页', to: '/' }, { label: '动漫资讯' }]}
      />

      <div className="w-full px-4 md:px-8 py-8 md:py-10">
        {paged.length > 0 ? (
          <>
            <div className="space-y-4">
              {paged.map((item) => (
                <Link
                  key={item.id}
                  to={`/news/${item.id}`}
                  className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
                >
                  <div className="w-full sm:w-52 h-40 sm:h-32 shrink-0 rounded-md overflow-hidden bg-background-200">
                    <img src={item.cover} alt={item.title} title={`${item.title} - 妖精动漫`} className="w-full h-full object-top group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  <div className="flex-1 min-w-0 flex flex-col">
                    <h2 className="text-base md:text-lg font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </h2>
                    <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">{item.summary}</p>
                    <div className="mt-auto pt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-400">
                      <span className="inline-flex items-center gap-1"><i className="ri-calendar-line"></i>{item.date}</span>
                      {item.author && <span className="inline-flex items-center gap-1"><i className="ri-user-line"></i>{item.author}</span>}
                      <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900">{item.category}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            <Pagination current={page} total={totalPages} onChange={setPage} />
          </>
        ) : (
          <EmptyState icon="ri-newspaper-line" title="暂无最新资讯，敬请期待" description="我们正在整理最新的动漫动态，稍后再来看看吧。" actionText="返回首页" actionTo="/" />
        )}
      </div>
    </div>
  );
}